/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 *
 * 2 = All
 */
export enum WorkshopGlobalFilterType {
  External = 0,
  SalesPreparation = 1,
  All = 2,
}
